export const profileTypes = {
  BANK_SETTINGS_CALL: 'BANK_SETTINGS_CALL',
  BANK_SETTINGS_SUCCESS: 'BANK_SETTINGS_SUCCESS',
  BANK_SETTINGS_FAILURE: 'BANK_SETTINGS_FAILURE',
  BANK_SETTINGS_LOADING: 'BANK_SETTINGS_LOADING',

  VERIFY_BANK_SETTINGS_LOADING: 'VERIFY_BANK_SETTINGS_LOADING',
  VERIFY_BANK_SETTINGS_SUCCESS: 'VERIFY_BANK_SETTINGS_SUCCESS',
  VERIFY_BANK_SETTINGS_FAILURE: 'VERIFY_BANK_SETTINGS_FAILURE',

  SETTINGS_LOADER: 'SETTINGS_LOADER',
  UPDATE_PROFILE_LOADING: 'UPDATE_PROFILE_LOADING',
  UPDATE_PROFILE_SUCCESS: 'UPDATE_PROFILE_SUCCESS',
  UPDATE_PROFILE_FAILURE: 'UPDATE_PROFILE_FAILURE',

  UPDATE_AVATAR_LOADING: 'UPDATE_AVATAR_LOADING',
  UPDATE_AVATAR_SUCCESS: 'UPDATE_AVATAR_SUCCESS',
  UPDATE_AVATAR_FAILURE: 'UPDATE_AVATAR_FAILURE',

  UPDATE_PASSWORD_LOADING: 'UPDATE_PASSWORD_LOADING',
  UPDATE_PASSWORD_SUCCESS: 'UPDATE_PASSWORD_SUCCESS',
  UPDATE_PASSWORD_FAILURE: 'UPDATE_PASSWORD_FAILURE',

  UPDATE_PIN_LOADING: 'UPDATE_PIN_LOADING',
  UPDATE_PIN_SUCCESS: 'UPDATE_PIN_SUCCESS',
  UPDATE_PIN_FAILURE: 'UPDATE_PIN_FAILURE',

  CREATE_PIN_SUCCESS: 'CREATE_PIN_SUCCESS',
  CREATE_PIN_FAILURE: 'CREATE_PIN_FAILURE',

  GET_NEXT_OF_KIN_LOADING: 'GET_NEXT_OF_KIN_LOADING',
  GET_NEXT_OF_KIN_SUCCESS: 'GET_NEXT_OF_KIN_SUCCESS',
  GET_NEXT_OF_KIN_FAILURE: 'GET_NEXT_OF_KIN_FAILURE',

  UPDATE_NEXT_OF_KIN_LOADING: 'UPDATE_NEXT_OF_KIN_LOADING',
  UPDATE_NEXT_OF_KIN_SUCCESS: 'UPDATE_NEXT_OF_KIN_SUCCESS',
  UPDATE_NEXT_OF_KIN_FAILURE: 'UPDATE_NEXT_OF_KIN_FAILURE',
}
